module.exports = __webpack_public_path__ + "img/ill_toko_unavailable.a02498be.svg";